<video
  #video
  id="my-video"
  class="video-js"
  controls
  controlsList="nodownload"
  preload="none"
  data-setup="{}"
>
  <source *ngIf="isMp4Source" [src]="url" type="video/mp4" />
  <source *ngIf="!isMp4Source" [src]="url" type="video/webm" />
</video>
